import axios from 'axios'
import axiosRetry from "axios-retry";
import store from '@/store';
import { requestOptions } from '@/helpers/request-options'

const accountApiClient = axios.create({
})

axiosRetry(accountApiClient, {
    retries: 3,
    retryDelay: () => 3000,
    retryCondition: () => true,
});

const apiSource = process.env.VUE_APP_API;

export default {
    GetRegisterModel() {
        return accountApiClient(
            requestOptions.get(
                apiSource + `/api/v1/${store.state.instance}/Account/Register`
            )
        )
    },
    PostRegistration(registrationContent) {
        return accountApiClient(
            requestOptions.postData(
                registrationContent,
                apiSource + `/api/v1/${store.state.instance}/Account/Register`
            )
        )
    },
    GetCompleteModel() {
        return accountApiClient(
            requestOptions.get(
                apiSource + `/api/v1/${store.state.instance}/Account/CompleteRegistration`
            )
        )
    },
    PostComplete(completeContent) {
        return accountApiClient(
            requestOptions.postData(
                completeContent,
                apiSource + `/api/v1/${store.state.instance}/Account/CompleteRegistration`
            )
        )
    },
    PostExternalComplete(completeContent) {
        return accountApiClient(
            requestOptions.postData(
                completeContent,
                apiSource + `/api/v1/${store.state.instance}/Account/ExternalCompleteRegistration`
            )
        )
    },
    ConfirmEmail(user, code) {
        return accountApiClient(
            requestOptions.get(
                apiSource + `/api/v1/${store.state.instance}/Account/ConfirmEmail?userId=${user}&code=${code}`
            )
        )
    },
    ForgotPassword(email) {
        var forgotRequest = { email: email };

        return accountApiClient(
            requestOptions.postData(
                forgotRequest,
                apiSource + `/api/v1/${store.state.instance}/Account/ForgotPassword`
            )
        )
    },
    ResetPassword(email, password, confirmpassword, code) {
        var resetRequest = { email: email, password: password, confirmpassword: confirmpassword, code: code };
        return accountApiClient(
            requestOptions.postData(
                resetRequest,
                apiSource + `/api/v1/${store.state.instance}/Account/ResetPassword`
            )
        )
    },
    ChangePassword(oldPassword, password, confirmpassword) {
        var resetRequest = { oldPassword: oldPassword, password: password, confirmpassword: confirmpassword };
        return accountApiClient(
            requestOptions.postData(
                resetRequest,
                apiSource + `/api/v1/${store.state.instance}/Account/ChangePassword`
            )
        )
    },
    GetProfileModel() {
        return accountApiClient(
            requestOptions.get(
                apiSource + `/api/v1/${store.state.instance}/Account/Profile`
            )
        );
    },
    GetProfileListings() {
        return accountApiClient(
            requestOptions.get(
                apiSource + `/api/v1/${store.state.instance}/Account/ProfileListings`
            )
        );
    },
    PostProfile(email, company, firstname, lastname, industryId, countryId, cadtool, address1, address2, address3, city, state, postalcode, phone) {
        var profilePostContent = { email: email, companyName: company, firstName: firstname, lastName: lastname, industryId: industryId, countryId: countryId, cadTool: cadtool, address1: address1, address2: address2, address3: address3, city: city, stateProvinceCounty: state, zipOrPostalCode: postalcode, phoneNumber: phone };
        return accountApiClient(
            requestOptions.postData(
                profilePostContent,
                apiSource + `/api/v1/${store.state.instance}/Account/Profile`
            )
        )
    },
    GetProfileSettings() {
        return accountApiClient(
            requestOptions.get(
                apiSource + `/api/v1/${store.state.instance}/Account/ProfileSettings`
            )
        );
    },
    PostPrivacy(privacyEntries) {
        return accountApiClient(
            requestOptions.postData(
                privacyEntries,
                apiSource + `/api/v1/${store.state.instance}/Account/UpdatePrivacySettings`
            )
        )
    },
    PostExport(exportEntries) {
        return accountApiClient(
            requestOptions.postData(
                exportEntries,
                apiSource + `/api/v1/${store.state.instance}/Account/UpdateExportSettings`
            )
        )
    },
    PostDelete() {
        return accountApiClient(
            requestOptions.post(
                apiSource + `/api/v1/${store.state.instance}/Account/DeleteAccount`
            )
        );
    }
}